export default [
  // {
  //   path: "footholdAnalysis",
  //   name: "footholdAnalysis",
  //   component: () =>
  //     import ("@/views/publicSecurityResearch/keyPersonnel/footholdAnalysis"),
  //   meta: {
  //     title: "落脚点分析"
  //   }
  // },
  {
    path: "frequentHaunt",
    name: "frequentHaunt",
    component: () =>
      import ("@/views/publicSecurityResearch/keyPersonnel/frequentHaunt/index.vue"),
    meta: {
      title: "频繁出没"
    }
  },
  {
    path: "firstAppearance",
    name: "firstAppearance",
    component: () =>
      import ("@/views/publicSecurityResearch/keyPersonnel/firstAppearance"),
    meta: {
      title: "首次出现"
    }
  },
  // {
  //   path: "regionalWandering",
  //   name: "regionalWandering",
  //   component: () =>
  //     import (
  //       "@/views/publicSecurityResearch/keyPersonnel/regionalWandering/index.vue"
  //     ),
  //   meta: {
  //     title: "区域徘徊"
  //   }
  // },
  {
    path: "outNight",
    name: "outNight",
    component: () =>
      import ("@/views/publicSecurityResearch/keyPersonnel/outNight/index.vue"),
    meta: {
      title: "昼伏夜出"
    }
  },
  // {
  //   path: "accompanyingPeers",
  //   name: "accompanyingPeers",
  //   component: () =>
  //     import ("@/views/publicSecurityResearch/keyPersonnel/accompanyingPeers"),
  //   meta: {
  //     title: "伴随同行"
  //   }
  // },
  // {
  //   path: "deckAnalysis",
  //   name: "deckAnalysis",
  //   component: () =>
  //     import ("@/views/publicSecurityResearch/keyKehicles/deckAnalysis.vue"),
  //   meta: {
  //     title: "套牌分析"
  //   }
  // },
  {
    path: "keyPersonnelBase",
    name: "keyPersonnelBase",
    component: () =>
      import (
        "@/views/publicSecurityResearch/keyPersonnel/keyPersonnelBase/keyPersonnelBase.vue"
      ),
    meta: {
      title: "重点人员库"
    }
  },
  // {
  //   path: "carFootholdAnalysis",
  //   name: "carFootholdAnalysis",
  //   component: () =>
  //     import (
  //       "@/views/publicSecurityResearch/keyKehicles/carFootholdAnalysis.vue"
  //     ),
  //   meta: {
  //     title: "落脚点分析"
  //   }
  // },
  // {
  //   path: "pathStrategy",
  //   name: "pathStrategy",
  //   component: () =>
  //     import ("@/views/publicSecurityResearch/keyKehicles/pathStrategy.vue"),
  //   meta: {
  //     title: "路径策略"
  //   }
  // },
  // {
  //   path: "carPeerAnalysis",
  //   name: "carPeerAnalysis",
  //   component: () =>
  //     import ("@/views/publicSecurityResearch/keyKehicles/carPeerAnalysis.vue"),
  //   meta: {
  //     title: "同行分析"
  //   }
  // },
  {
    path: "firstCity",
    name: "firstCity",
    component: () =>
      import ("@/views/publicSecurityResearch/keyKehicles/firstCity/index.vue"),
    meta: {
      title: "初次入城"
    }
  },
  {
    path: "carOutNight",
    name: "carOutNight",
    component: () =>
      import ("@/views/publicSecurityResearch/keyKehicles/carOutNight/index.vue"),
    meta: {
      title: "昼伏夜出"
    }
  },
  {
    path: "carFrequentHaunt",
    name: "carFrequentHaunt",
    component: () =>
      import ("@/views/publicSecurityResearch/keyKehicles/carFrequentHaunt/index.vue"),
    meta: {
      title: "频繁出没"
    }
  },
  {
    path: "keyPlaces",
    name: "keyPlaces",
    component: () =>
      import ("@/views/publicSecurityResearch/keyPlaces/keyPlaces.vue"),
    meta: {
      title: "重点场所"
    }
  },
  {
    path: "suspectedGroup",
    name: "suspectedGroup",
    component: () =>
      import ("@/views/publicSecurityResearch/keyPlaces/suspectedGroup.vue"),
    meta: {
      title: "疑似群租房和非法商用"
    }
  },
  {
    path: "modelConfiguration",
    name: "modelConfiguration",
    component: () =>
      import ("@/views/publicSecurityResearch/keyPlaces/modelConfiguration.vue"),
    meta: {
      title: "模型配置"
    }
  },
  {
    path: "drugControlModel",
    name: "drugControlModel",
    component: () =>
      import (
        "@/views/publicSecurityResearch/drugControlModel/drugControlModel.vue"
      ),
    meta: {
      title: "禁毒模型"
    }
  }
];